import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { activateBusiness } from 'api/admin/businesses/businesses';
import { ApiError } from 'types/api';

interface ActivateBusinessPayload {
  businessId: number;
  businessName: string;
  ownerFirstname: string;
  ownerLastname: string;
  ownerEmail: string;
  ownerPhone: string;
}

interface ActivateBusinessOptions {
  successCallback?: () => void;
}

interface SuccessResponse {
  success: boolean;
}

export const useActivateBusiness = ({ successCallback }: ActivateBusinessOptions = {}) => {
  return useMutation<unknown, ApiError, ActivateBusinessPayload>({
    mutationFn: async ({ businessId, ...data }) => {
      const { data: responseData } = (await activateBusiness(
        businessId,
        data,
      )) as AxiosResponse<SuccessResponse>;

      return responseData;
    },
    onSuccess: () => {
      successCallback?.();
      toast.success('Business activated. The owner will receive a welcome email to set their password.', {
        duration: 4000,
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'An error occurred while activating the business',
        {
          duration: 4000,
        },
      );
    },
  });
};
